import React from "react";
import { Container } from "react-bootstrap";
import parse from "html-react-parser";
import { AngelAiMessageBar } from "angelai-messagebar";
import "./searchbar.css"
import WidgetController from "./widgetcontroller"

const CustomHeader = ({ data }) => {
  return (
    <WidgetController showWidget={false}>
      <section className="searchbar-section">
        <span className="video-glow-blob-1" style={{top:'7%',left:'30%'}} />
        <span className="video-glow-blob-2" style={{top:'7%',left:'40%'}} />
        <span className="video-glow-blob-1" style={{top:'7%',left:'50%',background:'#FF541C'}} />
        <span className="video-glow-blob-2" style={{top:'7%',right:'30%',background:'#F31454'}} />
        <Container>
          {data && (
            <p className="searchbar-intro">
              {parse(data.introLine1)}
              <br />
              <span className="searchbar-intro-highlight">{parse(data.introLine2)}</span>
            </p>
          )}
          <div className="searchbar-wrapper">
            <AngelAiMessageBar comicBubbleBackground="#ffffff40"
              comicBubbleBorderColor="#FF6A1370" scrollToViewOnFocus={true} />
          </div>
        </Container>
      </section>
    </WidgetController>
  );
};
export default CustomHeader;
